import React from 'react';
import IconButton, { IconButtonProps } from '../../../iconButton/IconButton';
import './ActionsColumn.scss';
import { IconButtonType } from '../../../../libraries/IconButtonTheme';
const rootClassName = 'component-table-actions-column';

export const ActionsColumn = (props: { buttons?: IconButtonProps[] }) => {
  return (
    <div className={rootClassName}>
      {props.buttons && props.buttons.length
        ? props.buttons.map((btn, index) => {
            return (
              <IconButton key={index} theme={IconButtonType.Primary} {...btn} />
            );
          })
        : undefined}
    </div>
  );
};

ActionsColumn.defaultProps = {
  buttons: [],
};
